import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { PropertyDevice, DeviceType, LocationType, PowerStatus } from './property-device.model';
import { PaginationState } from '@lib/state';

export interface PropertyDeviceUIState {
  thingIdentifier?: string;
  thingLocationType?: LocationType;
  thingType?: DeviceType;
  thingStatus?: PowerStatus;
}

export interface PropertyDeviceState
  extends EntityState<PropertyDevice, PropertyDevice['thingName']> {
  ui: PropertyDeviceUIState;
  pagination: PaginationState;
}

@StoreConfig({ name: 'property-device', resettable: true, idKey: 'thingName' })
export class PropertyDeviceStore extends EntityStore<PropertyDeviceState> {
  constructor() {
    super({
      ui: {},
      pagination: { isDone: false },
    });
  }
}

/// This is a singleton store instance to be used across the application.
/// It ensures that the store is initialized only once and can be accessed globally.
/// This is to prevent circular dependencies and to provide a single source of truth for cost center options.
let _store: PropertyDeviceStore | undefined;
export function getPropertyDeviceStore(): PropertyDeviceStore {
  if (!_store) {
    _store = new PropertyDeviceStore();
  }
  return _store;
}
